import { render, staticRenderFns } from "./saas-nsr-footer.vue?vue&type=template&id=32a3b0ae&scoped=true"
import script from "./saas-nsr-footer.vue?vue&type=script&lang=js"
export * from "./saas-nsr-footer.vue?vue&type=script&lang=js"
import style0 from "./saas-nsr-footer.vue?vue&type=style&index=0&id=32a3b0ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3b0ae",
  null
  
)

export default component.exports